import Gun from "gun/gun"
export const gun = Gun({peers:['https://node.cloud0.digital/gun', 'https://node-gun.herokuapp.com/gun'], localStorage:true});